/* eslint-disable no-shadow */
// Needed for enums in ts

export enum RulesDirection {
  INCOMING = "incoming",
  OUTGOING = "outgoing",
}

export enum ActionRule {
  APPROVE = "APPROVE",
  REJECT = "REJECT",
  SEND_TO_INBOX = "SEND_TO_INBOX",
  NOT_READY = "NOT_READY",
}

export enum RuleCheck {
  ALL = "ALL",
  VASP = "VASP",
  JURISDICTION = "JURISDICTION",
  CUSTOMER_JURISDICTION = "CUSTOMER_JURISDICTION",
  RISK_SCORE = "RISK_SCORE",
  SANCTION_LIST_CHECK = "SANCTION_LIST_CHECK",
  TRANSACTION_AMOUNT = "TRANSACTION_AMOUNT",
  TRANSACTION_CREATION_TIME = "TRANSACTION_CREATION_TIME",
  REVIEWED_VASP_LIST = "REVIEWED_VASP_LIST",
  SELF_HOSTED_WALLET = "SELF_HOSTED_WALLET",
}

export enum RiskScoreRuleSource {
  CHAINALYSIS = "CHAINALYSIS",
  CHAINALYSIS2 = "CHAINALYSIS2",
  ELLIPTIC = "ELLIPTIC",
  TRM = "TRM",
  COINFIRM = "COINFIRM",
  CRYSTAL = "CRYSTAL",
  MERKLESCIENCE = "MERKLESCIENCE",
  SCORECHAIN = "SCORECHAIN",
}

export enum SanctionsListRuleSource {
  COMPLY_ADVANTAGE = "COMPLY_ADVANTAGE",
  LEXIS_NEXIS = "LEXISNEXIS",
  REFINITIV = "REFINITIV",
  TRM_SANCTIONS = "TRM_SANCTIONS",
}

export enum TransactionAmountOperator {
  GREATER_THAN = "greaterThan",
  LESS_THAN = "lessThan",
}

export enum TransactionCreationTimeOperator {
  OLDER_THAN = "olderThan",
  NEWER_THAN = "newwerThan",
}

export enum AdvancedRuleActionTypes {
  RULE_CHECK_CHANGE = "RULE_CHECK_CHANGE",
  VASP_CHANGE = "VASP_CHANGE",
  JURISDICTION_CHANGE = "JURISDICTION_CHANGE",
  CUSTOMER_JURISDICTION_CHANGE = "CUSTOMER_JURISDICTION_CHANGE",
  RISK_SCORE_SOURCE_CHANGE = "RISK_SCORE_SOURCE_CHANGE",
  REVIEWED_VASP_LIST_VALUE_CHANGE = "REVIEWED_VASP_LIST_VALUE_CHANGE",
  RISK_SCORE_VALUE_CHANGE = "RISK_SCORE_VALUE_CHANGE",
  SANCTIONS_LIST_SOURCE_CHANGE = "SANCTIONS_LIST_SOURCE_CHANGE",
  SANCTIONS_LIST_VALUE_CHANGE = "SANCTIONS_LIST_VALUE_CHANGE",
  ACTION_RULE_CHANGE = "ACTION_RULE_CHANGE",
  TRANSACTION_AMOUNT_OPERATOR_CHANGE = "TRANSACTION_AMOUNT_OPERATOR_CHANGE",
  TRANSACTION_AMOUNT_CURRENCY_CHANGE = "TRANSACTION_AMOUNT_CURRENCY_CHANGE",
  TRANSACTION_AMOUNT_VALUE_CHANGE = "TRANSACTION_AMOUNT_VALUE_CHANGE",
  TRANSACTION_CREATION_TIME_OPERATOR_CHANGE = "TRANSACTION_CREATION_TIME_OPERATOR_CHANGE",
  TRANSACTION_CREATION_TIME_VALUE_CHANGE = "TRANSACTION_CREATION_TIME_VALUE_CHANGE",
  SELF_HOSTED_WALLET_VALUE_CHANGE = "SELF_HOSTED_WALLET_VALUE_CHANGE",
}

export interface VaspsInfo {
  did: string;
  name: string;
}

export type RuleSetItem = {
  id?: string;
  order: number;
  actionRule: ActionRule | null;
  ruleCheck: RuleCheck | null;
  ruleValue: "ALL" | string | null;
  source?: RiskScoreRuleSource | SanctionsListRuleSource;
  direction?: RulesDirection;
  hasError?: boolean;
};
